import React, { useEffect } from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import HeaderBar from '../../components/HeaderBar/HeaderBar';


export default function Dashboard() {
  const { accessToken, signOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!accessToken) {
      navigate('/');
    }
  }, [accessToken, navigate]);

  const handleLogout = () => {
    signOut();
    navigate('/');
  };

  return (
    <>
    <HeaderBar 
      onLogout={handleLogout} 
      isLoggedIn={!!accessToken} 
    />
    <Box p={4}>
      {/* Additional dashboard content here */}
    </Box>
  </>

  );
}